import React from "react";
import {Button, Card, Col, DatePicker, Form, Icon, Input, Radio, message, Row, Spin, Table } from 'antd'
import {API, Auth} from "aws-amplify"
import "../../Styles/Services/checkInvoiceCSV.css"
import {connect} from "react-redux";
import {allDispatch as mapDispatchToProps, allState as mapStateToProps} from "../../Redux/Selectors";
import {withRouter} from "react-router-dom";
import moment from "moment";
import {CustomSpinner} from "../../Components/Spin/CustomSpiner";
import BaseDocumentControl from "./BaseDocumentControl";
import locale from "antd/es/date-picker/locale/es_ES";

import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';

class DocumentTypes extends React.Component {

    constructor(props) {
        super(props)
        this.myRef = React.createRef()
        this.myRefTable = React.createRef()
        this.state = {
            loading: true,
            documentTypes: [],
            documentType: {
                arnId: '',
                arnChecked: true,
                botRequired: 'not-required',
                key_words: '',
                name: '',
                type_document_id: null
            }
        }
    }

    getStringFilterProps = (property) => {
        return {
            filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
                <div style={{padding: 8}}>
                    <Input
                        ref={node => {
                            this.searchInput = node;
                        }}
                        placeholder="Buscar"
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => confirm()}
                        style={{width: 188, marginBottom: 8, display: 'block'}}
                    />
                    <Button
                        type="primary"
                        onClick={() => confirm()}
                        icon="search"
                        size="small"
                        style={{width: 90, marginRight: 8}}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters()}
                        size="small"
                        style={{width: 90}}
                    >
                        Reset
                    </Button>
                </div>
            ),
            filterIcon: filtered => (
                <Icon type="search" style={{color: filtered ? '#1890ff' : undefined}}/>
            ),
            onFilter: (value, record) => record[property].toString().toLowerCase().includes(value),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => this.searchInput.select())
                }
            }
        }
    }

    getDateFilterProps = (property) => {
        return {
            filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
                <div style={{padding: 8}}>
                    <DatePicker
                        placeholder={"Desde"}
                        value={selectedKeys[0] ? selectedKeys[0].from : null}
                        format="DD-MM-YYYY"
                        locale={locale}
                        disabledDate={d => !d || (selectedKeys[0] != null && d.isAfter(selectedKeys[0].to))}
                        onChange={e => setSelectedKeys([{from: e, to: (selectedKeys[0] ? selectedKeys[0].to : null)}])}
                        onPressEnter={() => confirm()}
                        style={{width: 188, marginBottom: 8, display: 'block'}}
                        allowClear={true}
                    />
                    <DatePicker
                        placeholder={"Hasta"}
                        disabledDate={d => !d || (selectedKeys[0] != null && d.isBefore(selectedKeys[0].from))}
                        value={selectedKeys[0] ? selectedKeys[0].to : null}
                        format="DD-MM-YYYY"
                        locale={locale}
                        onChange={e => setSelectedKeys([{
                            to: e,
                            from: (selectedKeys[0] ? selectedKeys[0].from : null)
                        }])}
                        onPressEnter={() => confirm()}
                        style={{width: 188, marginBottom: 8, display: 'block'}}
                        allowClear={true}
                    />
                    <Button
                        type="primary"
                        onClick={() => confirm()}
                        icon="search"
                        size="small"
                        style={{width: 90, marginRight: 8}}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters()}
                        size="small"
                        style={{width: 90}}
                    >
                        Reset
                    </Button>
                </div>
            ),
            filterIcon: filtered => (
                <Icon type="search" style={{color: filtered ? '#1890ff' : undefined}}/>
            ),
            onFilter: (value, record) => {
                const date = moment(record[property], 'YYYY-MM-DD');
                console.log({value, date})
                return date.isValid() && date.isAfter(value.from) && date.isBefore(value.to) || date.isSame(value.to) || date.isSame(value.from);
            }
        }
    }

    columns = [
        {
            title: 'Nombre',
            key: 'name',
            dataIndex: 'name'
        },
        /*{
            title: 'ARN ID',
            key: 'arnId',
            dataIndex: 'arnId',
            ...this.getStringFilterProps('arnId')
        },*/
        {
            title: 'Key Words',
            key: 'key_words',
            dataIndex: 'key_words',
            render: (value, row, index) => {
                let words = JSON.parse(value);
                let keyWords = Object.keys(words).join().replace(/,[s]*/g, ", ").replace(/,[s]*/g, ", ");
                return {
                    children: keyWords ? keyWords : ''
                }
            }
        },
        {
            title: 'BOT Required',
            key: 'botRequired',
            dataIndex: 'botRequired',
            render: (value, row, index) => {
                return {
                    children: value ? 'Required' : 'Not Required'
                }
            }
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record, index) => {
                return {
                    children: <>
                        <Button onClick={() => {
                            this.edit(record)
                        }}>
                            Editar
                        </Button>
                    </>
                }
            }
        }
    ]

    edit = record => {
        const docType = this.state.documentType
        docType['arnId'] = record.arnId
        docType['botRequired'] = record.botRequired ? 'required' : 'not-required'
        docType['key_words'] = record.key_words
        docType['name'] = record.name
        docType['type_document_id'] = record.type_document_id
        this.setState({ documentType: docType })
        this.myRef.current.scrollIntoView()
    }

    getDocumentTypes = () => {
        Promise.all([
            Auth.currentSession(),
            Auth.currentUserInfo()
        ]).then(([response, user]) => {
            API.get(
                'test',
                '/cd/cdtypedocument/',
                {
                    headers: {
                        Authorization: response.getIdToken().getJwtToken()
                    }
                }
            )
            .then(response => {
                console.log(JSON.stringify(response));
                this.setState({loading: false, documentTypes: response})
            })
            .catch(err => console.log(err))
        })
    }

    componentDidMount() {
        this.getDocumentTypes()
    }

    componentWillUnmount() {
    }

    updateData(field, value) {
        const data = this.state.documentType
        data[field] = value
        this.setState({ data })
    }

    save = () => {
        this.props.form.validateFields( { first: true }, (err, values) => {
            if (!err && this.state.documentType.key_words) {
               this.setState({ documentType: this.state.documentType, editting: false })
               this.send_data()
            }
        })
    }

    cancel = () => {
        this.setState({ loading: false, documentType: {} })
        this.setState({editting:false});
        this.props.form.resetFields();
        this.myRefTable.current.scrollIntoView()
    }

    send_data = () => {
        this.setState({ loading: true })
        Auth.currentSession()
        .then(session => {
            const arnId = this.state.documentType.arnChecked ? this.state.documentType.arnId : null
            const botRequired = this.state.documentType.botRequired === 'required' ? true : false
            const body ={
                name: this.state.documentType.name,
                arnId: arnId,
                key_words: this.state.documentType.key_words,
                botRequired,
                type_document_id: this.state.documentType.type_document_id
            }
            API.post(
                'test',
                '/cd/cdtypedocument/',
                {
                    headers: {
                        Authorization: session.getIdToken().getJwtToken()
                    },
                    body: body
                }
            )
            .then(response => {
                message.success("Tipo documento creado")
                this.setState({ loading: false, documentType: {} })
                this.getDocumentTypes()
            })
            .catch(err => {
                message.error("Error de creación de tipo documento")
                this.setState({ loading: false })
            })
        })
        .catch(err => {
            message.error("Error obteniendo credenciales de usuario")
            console.log(err)
        })
    }

    handleChange = record => {
        let documentTypeId = (this.state.documentType.type_document_id) ? this.state.documentType.type_document_id : null;
        let docType = { ...this.state.documentType, key_words: JSON.stringify(record), type_document_id: documentTypeId }
        this.setState({ documentType: docType })
    }

    render() {
        const {getFieldDecorator} = this.props.form
        if (this.state.loading) {
            return (
                <BaseDocumentControl selected='document-types'>
                    <Row type="flex" justify="space-around" align="middle" style={{marginTop: '150px'}}>
                        <Col style={{minHeight: '360px'}}>
                            <Spin indicator={CustomSpinner}/>
                        </Col>
                    </Row>
                </BaseDocumentControl>
            )
        } else {
            return (
                <BaseDocumentControl
                    selected='document-types'>
                    <Row>
                        <div ref={this.myRef}>
                            <Card title={'Alta Tipo Documento:'}>
                                <Col>
                                    <Form.Item label="Nombre">
                                        {
                                            getFieldDecorator('name', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Nombre es requerido'
                                                }],
                                                value: this.state.documentType.name,
                                                initialValue: this.state.documentType.name
                                            })(
                                            <Input
                                                value={this.state.documentType.name}
                                                onChange={(e) => this.updateData("name", e.target.value ? e.target.value : null)}
                                            />
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                                <Col>
                                    <Form.Item label="Bot Required">
                                        {
                                            getFieldDecorator('botRequired', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Bot Required es requerido'
                                                }],
                                                value: this.state.documentType.botRequired,
                                                initialValue: this.state.documentType.botRequired
                                            })(
                                            <Radio.Group onChange={(e) => this.updateData("botRequired", e.target.value)} value={this.state.documentType.botRequired}>
                                                <Radio.Button value={'required'}>Required</Radio.Button>
                                                <Radio.Button value={'not-required'}>Not required</Radio.Button>
                                            </Radio.Group>
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                                <Col>
                                    <Form.Item label="Key Words">
                                        {(
                                            <Editor
                                                search={false}
                                                key={this.state.documentType.type_document_id}
                                                value={(this.state.documentType.key_words) ? JSON.parse(this.state.documentType.key_words) : ''}
                                                onChange={this.handleChange}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Button
                                    style={{ marginBotton: '10px', marginLeft: '5px', marginTop: '5px' }}
                                    type="primary"
                                    icon="save"
                                    onClick={this.save}
                                >Guardar</Button>
                                <Button
                                    style={{ marginBotton: '10px', marginLeft: '5px', marginTop: '5px' }}
                                    icon="close"
                                    onClick={this.cancel}
                                >Cancelar</Button>
                            </Card>
                        </div>
                    </Row>
                    <br/>
                    <Row>
                        <div ref={this.myRefTable}>
                            <Card title={'Tipos Documento'}>
                                <Table
                                    columns={this.columns}
                                    dataSource={this.state.documentTypes}
                                    scroll={{x: "max-content"}}
                                    style={{margin: "20px"}}
                                    loading={this.state.loading}
                                    pagination={{
                                        showSizeChanger: true,
                                        pageSizeOptions: ['5', '10', '50'],
                                        defaultPageSize: 5,
                                        hideOnSinglePage: true
                                    }}
                                />
                            </Card>
                        </div>
                    </Row>
                </BaseDocumentControl>
            )
        }
    }
}

const DocumentTypesForm = Form.create({name: 'documentTypes'})(DocumentTypes)
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DocumentTypesForm))
